module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8019.a9ffea20.png";